import { TitleCasePipe } from '@angular/common';
import { Component, computed, input, signal } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ClientCompany } from 'src/app/interfaces/client';
import { User } from 'src/app/interfaces/user';
import { ReferenceService } from 'src/app/services/Reference/reference.service';
import { ValidationErrorComponent } from '../../../../../pages/public/register/common/validation-error/validation-error.component';
import { merge } from 'rxjs';

@Component({
  selector: 'other-information',
  imports: [ReactiveFormsModule, ValidationErrorComponent, TitleCasePipe],
  templateUrl: './other-information.component.html',
  styleUrl: './other-information.component.scss',
})
export class OtherInformationComponent {
  //DATA
  form = input.required<FormGroup>();
  sales_reps: User[] = [];
  companies = signal<ClientCompany[]>([]);
  available_companies = signal<ClientCompany[]>([])

  constructor(private referenceApi: ReferenceService) {}

  ngOnInit() {
    this.apiFetchSalesRep();
    this.apiFetchCompanies();
    this.processCompanies();
  }
  apiFetchSalesRep() {
    this.referenceApi.sales_rep().subscribe((res) => (this.sales_reps = res));
  }
  apiFetchCompanies() {
    this.referenceApi
      .companies()
      .subscribe((res) => (this.companies.set(res)));
  }
  processCompanies() {
    merge(
      this.form().get('category')!.valueChanges,
      this.form().get('sector')!.valueChanges
    ).subscribe(() => {
      const category = this.form().controls['category'].value;
      const sector = this.form().controls['sector'].value;

      const f_companies = this.companies().filter(
        (c) => c.sector === sector && c.category === category
      );
      this.available_companies.set(f_companies);
    });
  }
}
